const ErrorMessages = {
  ROUTE_NOT_FOUND: 'Route not found.',
  AUTH_INVALID_CREDENTIALS: 'Invalid credentials.',
  AUTH_USER_NOT_EXISTS_IN_THE_AUTH: 'User does not exist in the Auth.',
  AUTH_USER_IS_LOCKED: 'Your account is locked. Please contact your administrator for assistance.',
  AUTH_USER_NOT_FOUND: 'User not found for this token.',
  AUTH_GROUPS_CANNOT_BE_IMPERSONATED: 'Groups cannot be impersonated.',
  AUTH_SMART_CONTRACT_USERS_NOT_CREATED: 'Users not created.',
  AUTH_SMART_CONTRACT_USERS_NOT_UPDATED: 'Users not updated.',
  AUTH_SMART_CONTRACT_PASSWORD_NOT_RECOVERED: 'Password not recovered.',
  ALERT_PACKAGE_ID_OR_LEG_ID_IS_REQUIRED: 'Package ID or Leg ID is required',
  ASYNC_STORAGE_USER_NOT_FOUND: 'User not found in async storage.',
  CURRENT_BLOCK_NOT_FOUND: 'Current block not found',
  SMART_CONTRACT_NOT_FOUND: (address: string) => `Smart contract not found at address "${address}"`,
  OWNER_NOT_FOUND: (resource_id: string, owner_id: string) => `Owner ${owner_id} not found for resource ${resource_id}`,
  CUSTOMER_NOT_FOUND: (resource_id: string, customer_id: string) => `Customer ${customer_id} not found for resource ${resource_id}`,
  SHIPPER_NOT_FOUND: (resource_id: string, shipper_id: string) => `Shipper ${shipper_id} not found for resource ${resource_id}`,
  CONSIGNEE_NOT_FOUND: (resource_id: string, consignee_id: string) => `Consignee ${consignee_id} not found for resource ${resource_id}`,
  DOCUMENT_ALREADY_IN_VAULT: 'Binary is already secured in the vault',
  DOCUMENT_MUST_BE_BUFFER: 'Document must be a buffer',
  DOCUMENT_DOWNLOAD_FAILED: (message?: string) => `Failed to download the document (${message || 'unknown error'})`,
  DOCUMENT_NOT_FOUND: 'Document not found',
  DRIVER_NOT_ASSIGNED: 'Driver not assigned',
  DRIVER_NOT_FOUND: 'Driver not found',
  EMAIL_SEND_FAILED: 'Failed to send email',
  FILENAME_NOT_FOUND: (url: string) => `Filename not found in document URL "${url}"`,
  HEALTH_BLOCK_TIME_EXCEEDED: (blockNumber: number, maxTimeAllowed: number) => `Block ${blockNumber} took more than ${maxTimeAllowed}s to be mined.`,
  HEALTH_BLOCKS_NOT_FOUND: 'Blocks not found.',
  INTERNAL_SERVER_ERROR: 'Internal server error.',
  INVALID_FILENAME: 'Invalid filename.',
  INVALID_USER_ID: 'Invalid user ID.',
  INVALID_PERMISSION_TEMPLATE: 'Invalid permission template.',
  INVALID_VALUE_FOR_TYPE: (type: string, value: string) => `Invalid value "${value}" for type "${type}"`,
  LEG_SUPPLIER_IS_MISSING: 'Supplier ID is required',
  LEG_DOCUMENT_ALREADY_EXISTS: 'Document already exists for this leg',
  LEG_IS_ALREADY_COLLECTED: 'Leg is already collected',
  LEG_IS_ALREADY_DELIVERED: 'Leg is already delivered',
  LEG_MUST_BE_COLLECTED_BEFORE_DELIVERING: 'Leg must be collected first before delivering',
  LEG_POSITION_SHOULD_NOT_BE_NULL: 'All legs must have a non-null origin_position and destination_position.',
  LEG_LOGISTICS_EXPORT_PENDING: 'Leg needs to be fetched again',
  LEG_LOGISTICS_EXPORT_NOT_PENDING: 'Leg is already up to date',
  OWNER_ID_IS_REQUIRED: 'Owner ID is required',
  PACKAGE_NOT_FOUND: 'Package not found',
  PACKAGE_LOGISTICS_EXPORT_PENDING: 'Package needs to be fetched again',
  PACKAGE_LOGISTICS_EXPORT_NOT_PENDING: 'Package is already up to date',
  INTEGRATION_DELETION_NOT_PENDING: 'Deletion is already acknowledged',
  GEOFENCE_NOT_FOUND: 'Geofence data not found',
  PADDING_EXCEEDS_DATA_LENGTH: 'Padding exceeds data length',
  PDF_BLOB_IS_NOT_AVAILABLE: 'PDF blob is not available',
  POSITION_MUST_BE_AN_ARRAY: 'Position must be an array',
  RESOURCE_NOT_FOUND: (id: undefined | string) => (id ? `Resource ${id} not found.` : 'Resource not found.'),
  REPOSITORY_RESOURCE_NOT_FOUND: (id: string) => `Resource with id=${id} cannot be updated because it does not satisfy the where clause.`,
  REPOSITORY_OWNER_ID_IS_REQUIRED: (tableName: string) => `[${tableName}] Owner ID is required for write operations.`,
  REQUEST_TRANSACTION_TIMEOUT: (timeout: number) => `Transaction took more than ${timeout}s to process.`,
  PAYLOAD_VALIDATION_ERROR: (message: string) => message,
  PERMISSION_SUBJECT_INVALID: 'Permission subject is invalid',
  PERMISSION_RESOURCE_TRAVERSING_INVALID: "Permission resource can't traverse more than 5 levels above in the hierarchy",
  OPERATION_NOT_GRANTED: (operation: string, resource?: string) => `Operation "${operation}"${resource ? ` on resource ${resource}` : ''} not granted.`,
  SERVICE_IS_UNDER_MAINTENANCE: 'Service is under maintenance',
  SHIPMENT_IS_CANCELLED: 'Shipment is cancelled',
  SHIPMENT_IS_DRAFT: 'Shipment is in draft state',
  SHIPMENT_IS_DELIVERED: 'Shipment is already delivered',
  SHIPMENT_MISSING_GEOCODING: 'Shipment is missing geocoding.',
  SHIPMENT_MISSING_LEGS: 'Shipment is missing legs.',
  SHIPMENT_MISSING_PACKAGES: 'Shipment is missing packages.',
  SHIPMENT_NOT_FOUND: 'Shipment not found',
  SSO_ONLY: 'This user can only login via SSO.',
  STORAGE_DELETE_NOT_ALLOWED: (storageName: string) => `Delete not allowed in the ${storageName} storage.`,
  STORAGE_DOWNLOAD_FAILED: (filenameOrURL: string, errorMessage: string) => `Download failed for ${filenameOrURL}: ${errorMessage}`,
  STORAGE_FAILED_TO_GET_PRESIGNED_URL: 'Failed to get presigned URL',
  STORAGE_FILE_ALREADY_EXISTS: (storageName: string) => `This file already exists in the ${storageName} storage.`,
  STORAGE_FILE_NOT_FOUND: (filename: string) => `Document ${filename} not found.`,
  SUPPLIER_IS_NOT_GROUP: 'Supplier is not a group.',
  TOKEN_IS_REQUIRED: 'Token is required.',
  TOKEN_IS_INVALID: 'Token is invalid.',
  TRACKER_SMART_CONTRACT_NOT_FOUND: (trackerAddress: string) => `Tracker contract not found at address "${trackerAddress}"`,
  UNAUTHORIZED: 'Unauthorized.',
  USER_NOT_FOUND: 'User not found',
  USER_NOT_IN_GROUP: 'User is not in a group',
  USER_IS_NOT_A_GROUP: 'User is not a group',
  USER_IS_NOT_A_USER: 'User is not a user',
  VALUE_MUST_BE_A_NUMBER: 'Value must be a number',
  VAULT_SMART_CONTRACT_FILE_NOT_FOUND: 'File not found in Vault smart contract',
  VAULT_SMART_CONTRACT_NOT_FOUND: (vaultAddress: string) => `Vault contract not found at address "${vaultAddress}"`,
  WALLET_NOT_FOUND: 'Wallet not found',
  ROLE_HAS_USERS: 'Role cannot be removed if any group is still assign to it.',
  GROUP_HAS_USERS: 'Group has users',
  HIERARCHY_LOOP: 'The provided owner_id will cause a loop in the hierarchy.',
  USER_CANNOT_BE_RECOVERED: 'User cannot be recovered from blockchain: owner_id and/or is_group mismatch.',
  OWNERSHIP_CANNOT_BE_CHANGED: 'Ownership of this resource cannot be changed after creation.',
  ROLE_FOR_USER_INVALID: 'Role for user must be MEMBER.',
  ROLE_FOR_SUPERADMIN_INVALID: 'Role for superadmin group must be SUPERADMIN.',
  ROLE_REASSIGN_IN_PROGRESS: 'A reassign is already in progress for this role.',
  REASSIGN_QUEUE_FULL: (max: number) => `The reassign queue is full (${max} running or queued). Cancel a pending reassign to make room.`,
  CANNOT_CANCEL_RUNNING_REASSIGN: 'This reassign has already started and can no longer be cancelled.',
  PERMISSION_CREATION_FAILED: 'Permission creation failed',
  BRIDGE_SCOPE_VIOLATION: 'Bridge scope violation.',
  SUPPORT_REQUEST_CONFLICT: 'Operator already has an active support grant.',
  SUPPORT_REQUEST_NOT_FOUND: 'Support request not found.',
  SUPPORT_REQUEST_INVALID_STATUS: (expected: string, actual: string) => `Support request status must be "${expected}" but is "${actual}".`,
} as const;

export type ErrorMessage = string;

export default ErrorMessages;
